/**
 * Funções utilitárias de formatação para a feature de Laudo
 */

/**
 * Formata uma data ISO para formato brasileiro
 * @param dateString - String de data em formato ISO
 * @returns Data formatada em pt-BR (DD/MM/YYYY HH:mm)
 */
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Formata o tamanho de arquivo em bytes para MB
 * @param bytes - Tamanho em bytes
 * @returns Tamanho formatado em MB (ex: "1,23 MB")
 */
export function formatFileSize(bytes: number): string {
  return `${(bytes / 1024 / 1024).toFixed(2).replace('.', ',')} MB`;
}

/**
 * Formata valor monetário para Real brasileiro
 * @param value - Valor numérico
 * @returns Valor formatado em R$ (ex: "R$ 1.234,56")
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

/**
 * Formata valor monetário a partir de string
 * @param value - Valor como string
 * @returns Valor formatado em R$ ou string original se não for número
 */
export function formatCurrencyFromString(value: string): string {
  const numValue = parseFloat(value.replace(/[^\d.-]/g, ''));
  if (isNaN(numValue)) return value;
  return formatCurrency(numValue);
}

/**
 * Formata área em metros quadrados
 * @param value - Valor da área
 * @returns Área formatada (ex: "100,00 m²")
 */
export function formatArea(value: number): string {
  return `${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m²`;
}
